import React from "react"
import { useNavigate } from "react-router-dom";


function Auth(props) {
  const navigate = useNavigate();




  const handleSubmit = (event) => {
    event.preventDefault();
    const email = event.target.elements.email.value;
    const password = event.target.elements.password.value;
    const logindata = { email, password }; // create an object with email and password properties

    fetch("http://crm.arunexcello.com:3000/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(logindata),
    })
      .then((data) => {

        if (data.status === 200 || data.statusText === 'success') {
          sessionStorage.setItem("isAdmin", true);
          navigate("/home")
        }
        else {
          alert("Login Failed :(");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };



  return (
    <div className="Auth-form-container">
      <form className="Auth-form" onSubmit={handleSubmit}>
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Sign In</h3>
          <div className="form-group mt-3">
            <label>Email address</label>
            <input
              type="email"
              className="form-control mt-1"
              placeholder="Enter email"
              name="email"
            />
          </div>
          <div className="form-group mt-3">
            <label>Password</label>
            <input
              type="password"
              className="form-control mt-1"
              placeholder="Enter password"
              name="password"
            />
          </div>
          <div className="d-grid gap-2 mt-3">
            <button type="submit" className="btn btn-primary">
              Submit
            </button>

          </div>
        </div>
      </form>
    </div>
  );
}

export default Auth;
